import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/*
* This modal is used to warn the user that they have unsaved changes in the audience and are trying to navigate away from the page.
* @param {boolean} isShowing - Whether the modal is showing or not
* @param {function} hide - Function to hide the modal
* @param {function} onClickContinueHandler - Function to call when the user clicks continue
*/
const AudienceUnsavedModal = ({isShowing, hide, onClickContinueHandler}) => {

  const onContinue = () => {
    hide();
    onClickContinueHandler();
  };

  return (
    <Modal
      size="lg"
      centered
      isOpen={isShowing}
      backdrop
    >
      <ModalHeader>Unsaved Audience Changes</ModalHeader>
      <ModalBody>
        <h2>Your audience changes will be lost!</h2>
        <p>
          To keep them, save your changes from Audience Actions before continuing.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={hide}>Cancel</Button>
        <Button onClick={onContinue}>Continue</Button>
        <Button className={" promote"} onClick={hide}>
          Return to editing audience
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AudienceUnsavedModal;
